import { dateFormatter, getNum } from '../../utils/formaters';
/* eslint-disable indent */
const TotalTableItemDtoToTotalTableItem = (TotalTableDto) => TotalTableDto?.map(dto => ({
    plate: dto.placa || '-',
    brand: dto.marca || '-',
    model: dto.modelo || '-',
    color: dto.cor || '-',
    region: dto.regiao || '-',
    uf: dto.uf || '-',
    city: dto.cidade || '-',
}));
export const TotalTableDtoToTotalTable = (TotalTableDto) => ({
    itens: TotalTableItemDtoToTotalTableItem(TotalTableDto.listagem),
    pageCount: TotalTableDto.totalPaginas,
    rows: TotalTableDto.totalRegistros,
});
const AgeTableItemDtoToAgeTableItem = (AgeTableDto) => AgeTableDto?.map(dto => ({
    age: dto.idadeMes || '-',
    plate: dto.placa || '-',
    brand: dto.marca || '-',
    model: dto.modelo || '-',
    color: dto.cor || '-',
    region: dto.regiao || '-',
    uf: dto.uf || '-',
    city: dto.cidade || '-',
    modelYear: dto.anoModelo || '-',
    county: dto.municipio || '-',
    personId: dto.pessoaId || '-',
}));
export const AgeTableDtoToAgeTable = (AgeTableDto) => ({
    itens: AgeTableItemDtoToAgeTableItem(AgeTableDto.listagem),
    pageCount: AgeTableDto.totalPaginas,
    rows: AgeTableDto.totalRegistros,
});
const KmTableItemDtoToKmTableItem = (KmTableDto) => KmTableDto?.map(dto => ({
    km: dto.kmAtual || '-',
    plate: dto.placa || '-',
    brand: dto.marca || '-',
    model: dto.modelo || '-',
    color: dto.cor || '-',
    region: dto.regiao || '-',
    uf: dto.uf || '-',
    city: dto.cidade || '-',
    modelYear: dto.anoModelo || '-',
    county: dto.municipio || '-',
    personId: dto.pessoaId || '-',
}));
export const KmTableDtoToKmTable = (KmTableDto) => ({
    itens: KmTableItemDtoToKmTableItem(KmTableDto.listagem),
    pageCount: KmTableDto.totalPaginas,
    rows: KmTableDto.totalRegistros,
});
//TOTAL
const TotalValueDtoToTotalValue = (title, dto) => dto === 0 || !dto
    ? undefined
    : {
        label: title || '',
        value: dto || 0,
    };
const TotalChartRegionsDtoToTotalChartRegions = (dto) => ({
    cw: TotalValueDtoToTotalValue('Centro-Oeste', dto.centroOeste),
    ne: TotalValueDtoToTotalValue('Nordeste', dto.nordeste),
    no: TotalValueDtoToTotalValue('Norte', dto.norte),
    se: TotalValueDtoToTotalValue('Sudeste', dto.sudeste),
    so: TotalValueDtoToTotalValue('Sul', dto.sul),
    total: TotalValueDtoToTotalValue('Total', dto.total),
});
const TotalChartStatesDtoToTotalChartStates = (dto) => ({
    ac: TotalValueDtoToTotalValue('Acre', dto.AC),
    al: TotalValueDtoToTotalValue('Alagoas', dto.AL),
    ap: TotalValueDtoToTotalValue('Amapá', dto.AP),
    am: TotalValueDtoToTotalValue('Amazonas', dto.AM),
    ba: TotalValueDtoToTotalValue('Bahia', dto.BA),
    ce: TotalValueDtoToTotalValue('Ceará', dto.CE),
    es: TotalValueDtoToTotalValue('Espírito Santo', dto.ES),
    go: TotalValueDtoToTotalValue('Goiás', dto.GO),
    ma: TotalValueDtoToTotalValue('Maranhão', dto.MA),
    mt: TotalValueDtoToTotalValue('Mato Grosso', dto.MT),
    ms: TotalValueDtoToTotalValue('Mato Grosso do Sul', dto.MS),
    mg: TotalValueDtoToTotalValue('Minas Gerais', dto.MG),
    pa: TotalValueDtoToTotalValue('Pará', dto.PA),
    pb: TotalValueDtoToTotalValue('Paraíba', dto.PB),
    pr: TotalValueDtoToTotalValue('Pará', dto.PR),
    pe: TotalValueDtoToTotalValue('Pernambuco', dto.PE),
    pi: TotalValueDtoToTotalValue('Piauí', dto.PI),
    rj: TotalValueDtoToTotalValue('Rio de Janeiro', dto.RJ),
    rn: TotalValueDtoToTotalValue('Rio Grande do Norte', dto.RN),
    rs: TotalValueDtoToTotalValue('Rio Grande do Sul', dto.RS),
    ro: TotalValueDtoToTotalValue('Rondônia', dto.RO),
    rr: TotalValueDtoToTotalValue('Roraima', dto.RR),
    sc: TotalValueDtoToTotalValue('Santa Catarina', dto.SC),
    sp: TotalValueDtoToTotalValue('São Paulo', dto.SP),
    se: TotalValueDtoToTotalValue('Sergipe', dto.SE),
    to: TotalValueDtoToTotalValue('Tocantins', dto.TO),
    df: TotalValueDtoToTotalValue('Distrito Federal', dto.DF),
});
export const TotalChartDtoToTotalChartChart = (totalChartDto) => ({
    count: TotalChartRegionsDtoToTotalChartRegions(totalChartDto.contagem),
    statesCount: TotalChartStatesDtoToTotalChartStates(totalChartDto.contagemPorEstado),
});
//AGE
const AgeRangeDtoToAgeRange = (dto) => dto
    ? {
        total: getNum(dto.valores['0-1']) +
            getNum(dto.valores['1-2']) +
            getNum(dto.valores['2-3']) +
            getNum(dto.valores['3-4']) +
            getNum(dto.valores['4-5']) +
            getNum(dto.valores['+5']),
        values: [
            { label: 'Até 12 meses', value: dto.valores['0-1'] || 0 },
            { label: '13-24 meses', value: dto.valores['1-2'] || 0 },
            { label: '25-36 meses', value: dto.valores['2-3'] || 0 },
            { label: '37-48 meses', value: dto.valores['3-4'] || 0 },
            { label: '49-60 meses', value: dto.valores['4-5'] || 0 },
            { label: '+60 meses', value: dto.valores['+5'] || 0 },
        ],
    }
    : undefined;
const AgeChartRegionsDtoToAgeChartRegions = (regionAgeDto) => ({
    br: AgeRangeDtoToAgeRange(regionAgeDto.filter(dto => dto.regiao === 'BRASIL')[0]),
    cw: AgeRangeDtoToAgeRange(regionAgeDto.filter(dto => dto.regiao === 'CENTRO-OESTE')[0]),
    ne: AgeRangeDtoToAgeRange(regionAgeDto.filter(dto => dto.regiao === 'NORDESTE')[0]),
    no: AgeRangeDtoToAgeRange(regionAgeDto.filter(dto => dto.regiao === 'NORTE')[0]),
    se: AgeRangeDtoToAgeRange(regionAgeDto.filter(dto => dto.regiao === 'SUDESTE')[0]),
    so: AgeRangeDtoToAgeRange(regionAgeDto.filter(dto => dto.regiao === 'SUL')[0]),
});
const AgeChartStatesDtoToAgeChartStates = (statesDto) => ({
    ac: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'AC')[0]),
    al: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'AL')[0]),
    ap: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'AP')[0]),
    am: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'AM')[0]),
    ba: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'BA')[0]),
    ce: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'CE')[0]),
    es: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'ES')[0]),
    go: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'GO')[0]),
    ma: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'MA')[0]),
    mt: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'MT')[0]),
    ms: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'MS')[0]),
    mg: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'MG')[0]),
    pa: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'PA')[0]),
    pb: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'PB')[0]),
    pr: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'PR')[0]),
    pe: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'PE')[0]),
    pi: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'PI')[0]),
    rj: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'RJ')[0]),
    rn: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'RN')[0]),
    rs: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'RS')[0]),
    ro: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'RO')[0]),
    rr: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'RR')[0]),
    sc: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'SC')[0]),
    sp: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'SP')[0]),
    se: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'SE')[0]),
    to: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'TO')[0]),
    df: AgeRangeDtoToAgeRange(statesDto.filter(dto => dto.estado === 'DF')[0]),
});
export const AgeChartDtoToAgeChartChart = (ageChartDto) => ({
    count: AgeChartRegionsDtoToAgeChartRegions(ageChartDto.contagem),
    statesCount: AgeChartStatesDtoToAgeChartStates(ageChartDto.contagemPorEstado),
});
//KM
const KmRangeDtoToKmRange = (dto) => dto
    ? {
        total: getNum(dto.valores['0-20']) +
            getNum(dto.valores['20-50']) +
            getNum(dto.valores['50-100']) +
            getNum(dto.valores['+100']),
        values: [
            { label: '0-20 mil', value: dto.valores['0-20'] || 0 },
            { label: '20-50 mil', value: dto.valores['20-50'] || 0 },
            { label: '50-100 mil', value: dto.valores['50-100'] || 0 },
            { label: '+100 mil', value: dto.valores['+100'] || 0 },
        ],
    }
    : undefined;
const KmChartRegionsDtoToKmChartRegions = (regionKmDto) => ({
    br: KmRangeDtoToKmRange(regionKmDto.filter(dto => dto.regiao === 'BRASIL')[0]),
    cw: KmRangeDtoToKmRange(regionKmDto.filter(dto => dto.regiao === 'CENTRO-OESTE')[0]),
    ne: KmRangeDtoToKmRange(regionKmDto.filter(dto => dto.regiao === 'NORDESTE')[0]),
    no: KmRangeDtoToKmRange(regionKmDto.filter(dto => dto.regiao === 'NORTE')[0]),
    se: KmRangeDtoToKmRange(regionKmDto.filter(dto => dto.regiao === 'SUDESTE')[0]),
    so: KmRangeDtoToKmRange(regionKmDto.filter(dto => dto.regiao === 'SUL')[0]),
});
const KmChartStatesDtoToKmChartStates = (stateKmDto) => ({
    ac: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'AC')[0]),
    al: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'AL')[0]),
    ap: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'AP')[0]),
    am: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'AM')[0]),
    ba: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'BA')[0]),
    ce: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'CE')[0]),
    es: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'ES')[0]),
    go: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'GO')[0]),
    ma: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'MA')[0]),
    mt: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'MT')[0]),
    ms: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'MS')[0]),
    mg: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'MG')[0]),
    pa: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'PA')[0]),
    pb: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'PB')[0]),
    pr: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'PR')[0]),
    pe: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'PE')[0]),
    pi: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'PI')[0]),
    rj: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'RJ')[0]),
    rn: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'RN')[0]),
    rs: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'RS')[0]),
    ro: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'RO')[0]),
    rr: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'RR')[0]),
    sc: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'SC')[0]),
    sp: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'SP')[0]),
    se: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'SE')[0]),
    to: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'TO')[0]),
    df: KmRangeDtoToKmRange(stateKmDto.filter(dto => dto.estado === 'DF')[0]),
});
export const KmChartDtoToKmChartChart = (kmChartDto) => ({
    count: KmChartRegionsDtoToKmChartRegions(kmChartDto.contagem),
    statesCount: KmChartStatesDtoToKmChartStates(kmChartDto.contagemPorEstado),
});
const AverageKmTableItemDtoAverageKmalTableItem = (averageKmTableDto) => averageKmTableDto?.map(dto => ({
    plate: dto.placa || '-',
    brand: dto.marca || '-',
    model: dto.modelo || '-',
    contractDeadline: dto.prazo_contrato || '-',
    deliveryDate: dto.data_entrega_cliente
        ? dateFormatter(dto.data_entrega_cliente)
        : '-',
    lastRevisionKm: dto.km_ultimo_revisao || '-',
    lastTicketDate: dto.data_ultimo_chamado
        ? dateFormatter(dto.data_ultimo_chamado)
        : '-',
    averageKm: dto.km_medio || '-',
}));
export const AverageKmTableDtoAverageKmalTable = (averageKmTableDto) => ({
    itens: AverageKmTableItemDtoAverageKmalTableItem(averageKmTableDto.listagem),
    pageCount: averageKmTableDto.totalPaginas,
    rows: averageKmTableDto.totalRegistros,
});
